"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumUniversalLinkPath = exports.TX_CORP_ID = exports.EnumLaunchFrom = exports.EnumLaunchType = exports.EnumLaunchMode = void 0;
/**
 * 唤起模式枚举
 * 小程序
 * 扫码
 */
var EnumLaunchMode;
(function (EnumLaunchMode) {
    /**
     * 无效邀请（旧版本客户端打开特邀会议邀请链接）
     */
    EnumLaunchMode[EnumLaunchMode["NotValid"] = 0] = "NotValid";
    /**
     * 小程序、公众号push
     */
    EnumLaunchMode[EnumLaunchMode["MiniProgram"] = 1] = "MiniProgram";
    /**
     * 桌面端扫码
     */
    EnumLaunchMode[EnumLaunchMode["QrCode"] = 2] = "QrCode";
})(EnumLaunchMode = exports.EnumLaunchMode || (exports.EnumLaunchMode = {}));
/**
 * 唤起类型枚举
 * 入会
 * 唤起
 */
var EnumLaunchType;
(function (EnumLaunchType) {
    /**
     * 会议号入会
     */
    EnumLaunchType[EnumLaunchType["MeetingCode"] = 0] = "MeetingCode";
    /**
     * 唤起app
     */
    EnumLaunchType[EnumLaunchType["LaunchApp"] = 1] = "LaunchApp";
})(EnumLaunchType = exports.EnumLaunchType || (exports.EnumLaunchType = {}));
/**
 * 唤起app会议种类常量
 */
var EnumLaunchFrom;
(function (EnumLaunchFrom) {
    /**
     * 普通会议
     */
    EnumLaunchFrom[EnumLaunchFrom["NormalMeeting"] = 1] = "NormalMeeting";
    /**
     * 周期性会议
     */
    EnumLaunchFrom[EnumLaunchFrom["PeriodicalMeeting"] = 2] = "PeriodicalMeeting";
    /**
     * PMI会议
     */
    EnumLaunchFrom[EnumLaunchFrom["Pmi"] = 3] = "Pmi";
    /**
     * 特邀会议扫码
     */
    EnumLaunchFrom[EnumLaunchFrom["QrCode"] = 4] = "QrCode";
    /**
     * 特邀会议：小程序、公众号push
     */
    EnumLaunchFrom[EnumLaunchFrom["MiniProgram"] = 5] = "MiniProgram";
})(EnumLaunchFrom = exports.EnumLaunchFrom || (exports.EnumLaunchFrom = {}));
exports.TX_CORP_ID = 'wxab249edd27d57738';
/**
 * Universal link路径
 */
var EnumUniversalLinkPath;
(function (EnumUniversalLinkPath) {
    EnumUniversalLinkPath["Test"] = "https://test.txmeeting.tencent.com/ulink/inmeeting";
    EnumUniversalLinkPath["Prod"] = "https://meeting.tencent.com/ulink/inmeeting";
    EnumUniversalLinkPath["OldProd"] = "https://meeting.qq.com/s";
})(EnumUniversalLinkPath = exports.EnumUniversalLinkPath || (exports.EnumUniversalLinkPath = {}));
//# sourceMappingURL=launch.js.map